import { SparkleIcon } from "./icons";

export type AiHeaderProps = {
  isRefining?: boolean;
};

export function AiHeader({ isRefining }: AiHeaderProps) {
  return (
    <div className="mb-4">
      {/* Header */}
      <div className="mb-1 flex items-center gap-2">
        <SparkleIcon className="size-6" />
        <div className="flex items-baseline gap-1">
          <h1 className="text-cta-gradient leading-7.5 text-xl font-semibold">Weave AI</h1>
          <span className="text-sm font-semibold leading-5 text-green-600">Free</span>
        </div>
      </div>

      {/* Title with Badge */}
      <div className="mb-1 flex items-center gap-2">
        <h2 className="text-base font-semibold leading-6 text-gray-600">
          Generate Your Own Artwork
        </h2>
        <span className="bg-cta-gradient leading-4.5 rounded-lg px-2 py-0.5 text-center align-middle text-xs font-normal text-white shadow-sm">
          New Feature
        </span>
      </div>

      {/* Description */}
      <p className="align-middle text-xs font-normal leading-[18px] text-gray-500">
        Describe the design you want to create, and our AI will generate unique images, logos, and
        artwork based on your input.{" "}
        {isRefining
          ? `From the generated options, you can choose the design you like
        best and refine it further to match your exact vision.`
          : ""}
      </p>
    </div>
  );
}
